import { Component, Input, OnInit, SimpleChanges, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatSliderChange } from '@angular/material/slider';
import { Subscription, pairwise, startWith } from 'rxjs';

@Component({
    selector: 'app-staff-salary',
    templateUrl: './staff-salary.component.html',
    styleUrls: ['./staff-salary.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => StaffSalaryComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => StaffSalaryComponent),
            multi: true
        }
    ],
    standalone: false
})
export class StaffSalaryComponent implements OnInit {
  public hr: boolean = false;
  public staffSalaryFormSubscription: Subscription | undefined;
  public isFormTouched = false;
  @Input() form: any = {};
  @Input() isEdit : boolean = false;
  @Input() model: any = {};
  
  public staffSalaryForm: UntypedFormGroup = new UntypedFormGroup({
    salary: new UntypedFormControl(null,[Validators.required]),
    hourly_pay: new UntypedFormControl(null),
    salary_level: new UntypedFormControl(null),
  });
  constructor() { }

  ngOnInit(): void {
    this.initSubscriptions()
  }

  ngOnChanges(changes: SimpleChanges) {
    this.model = changes?.model?.currentValue;
  }

  ngAfterViewInit(): void {
    this.setDataOnEdit();
  }

  setDataOnEdit = () => {
    if(this.isEdit) {
      this.staffSalaryForm.get('salary')?.setValue(this.model?.staff_detail?.salary);
      this.staffSalaryForm.get('salary_level')?.setValue(this.model?.staff_detail?.salary);
      this.staffSalaryForm.get('hourly_pay')?.setValue(this.model?.staff_detail?.hourly_pay)
    }
  }

  formatLabel(value: number): string {
    if (value >= 1000) {
      return (value / 1000).toFixed(1) + 'k';
    }

    return `${value}`;
  }

  writeValue(val: any): void {
    val && this.staffSalaryForm.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.staffSalaryForm.valueChanges.subscribe(fn);
  }
  onInputChange(event: MatSliderChange) {
    this.staffSalaryForm.controls['salary'].setValue(event.value);
  }
  onValueInput(event: any){
    const salaryLevel = this.staffSalaryForm.controls['salary']?.value;
    this.staffSalaryForm.controls['salary_level'].setValue(salaryLevel);
  }
 
  public onTouched: () => void = () => {};
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.staffSalaryForm.disable() : this.staffSalaryForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null{
    return this.staffSalaryForm.valid ? null : { invalidForm: {valid: false, message: "Company name fields are invalid"}};
  }

  onChangeHourlyPay(){
    this.hr = !this.hr
  const hourlyPayValue = this.staffSalaryForm.get('hourly_pay')?.value;
  if (hourlyPayValue) {
    this.hr = true;
  }
  }
  initSubscriptions(){
    if (this.form){
      this.staffSalaryFormSubscription = this.form.valueChanges
        .pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (this.form.touched && !this.isFormTouched){
            this.isFormTouched = true;
            this.touchFormControls();
          }
        });
    }
  }

  touchFormControls(){
    Object.keys(this.staffSalaryForm.controls).forEach(key => {
      this.staffSalaryForm.get(key)?.markAsTouched();
    });
  }
}
